import React from 'react';
import { ReactComponent as LogoSVG } from './spotii-zip-logo.svg';

export default function SpotiiZipLogo() {
  return <LogoSVG />;
}
